import {
  Component,
  OnDestroy,
  OnInit,
  signal,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CompanySettingsService } from '../../services/api/company-settings.service';
import { CompanySettings } from '../../model/company-settings/company-settings';
import { QuotaService } from '../../services/api/quota.service';
import { ApplicationSettings } from '../../model/company-settings/application-settings';
import { FeatureConfigurationDataService } from '../../services/data/feature-configuration-data.service';
import { FeatureConfiguration } from '../../model/plan/feature-configuration';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss'],
  providers: [QuotaService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MenuBarComponent implements OnInit, OnDestroy {
  protected companySettings$ = signal<CompanySettings | null>(null);
  protected applicationSettings$ = signal<ApplicationSettings | null>(null);
  protected featureConfiguration$ = signal<FeatureConfiguration | null>(null);
  private readonly unsubscribe$ = new Subject<void>();

  readonly navigationAvailable = input(true);
  readonly navigationExpanded = input(false);
  readonly navigationToggle = output<MouseEvent>();

  constructor(
    private readonly featureConfigurationDataService: FeatureConfigurationDataService,
    private readonly companySettingsService: CompanySettingsService,
  ) {}

  ngOnInit(): void {
    this.getFeatureConfiguration();
    this.getCompanySettings();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private getFeatureConfiguration() {
    this.featureConfigurationDataService.featureConfiguration$.subscribe(
      (featureConfiguration) => {
        this.featureConfiguration$.set(featureConfiguration);
      },
    );
  }

  private getCompanySettings(): void {
    this.companySettingsService
      .getCompanySettings()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((settings) => {
        this.companySettings$.set(settings);
        this.applicationSettings$.set(settings.applicationSettings ?? null);
      });

    this.companySettingsService.loadCompanyData().subscribe();
  }
}
